import { render, staticRenderFns } from "./license-details.vue?vue&type=template&id=5277ff2e&scoped=true"
import script from "./license-details.vue?vue&type=script&lang=js"
export * from "./license-details.vue?vue&type=script&lang=js"
import style0 from "./license-details.vue?vue&type=style&index=0&id=5277ff2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277ff2e",
  null
  
)

export default component.exports